import script from "./LoaderComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./LoaderComponent.vue?vue&type=script&setup=true&lang=js"

import "./LoaderComponent.vue?vue&type=style&index=0&id=5e74b86c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e74b86c"]])

export default __exports__